export default function permission({ next, store, to }) {
  const requiredPermission = to.meta.permission;

  if (!requiredPermission) {
    return next();
  }

  const hasPermission =
    store.getters["auth/has_module_permission"](requiredPermission);

  if (!hasPermission) {
    if (to.name === "dashboard") {
      return next();
    }
    return next({ name: "dashboard" });
  }

  return next();
}
